import { render, staticRenderFns } from "./AIQnaChatModal.vue?vue&type=template&id=50ddc44e&scoped=true&"
import script from "./AIQnaChatModal.vue?vue&type=script&lang=js&"
export * from "./AIQnaChatModal.vue?vue&type=script&lang=js&"
import style0 from "./AIQnaChatModal.vue?vue&type=style&index=0&id=50ddc44e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ddc44e",
  null
  
)

export default component.exports